export const TAXABLE = 'taxable';
export const TAX_FREE = 'tax-free';
export const ZERO_TAX_RATE_CUSTOMS_EXPORT = 'zero-tax-rate-customs-export';
export const ZERO_TAX_RATE_NON_CUSTOMS_EXPORT =
  'zero-tax-rate-non-customs-export';
